import {
  LLMStreamEventLabel,
  IndexReference,
  LLMStreamEventRole,
  LLMStreamEventType,
  IOMainLLMMessage,
  LLMMessageCategoryToDisplayType,
  LLMTypeToRoleAndCategory,
  IOBasicMessage,
  LLMStreamEventRolePlus,
  Workflow,
  getWorkflows,
} from "./rest_utils";
import {
  insertCommentIntoWord,
  replaceHtmlBodyContent,
  searchTextinDocument,
  onContentChange,
  getSelectedText,
  insertHtmlAtSelection,
  replaceSavedSelection,
  searchAndDeleteText,
  searchAndReplaceText,
  searchAndSelectText,
  insertAtCurrentPosition,
  fixWordImgSrc,
  replaceImagesWithBase64,
  resetWordImageMap,
  getSelectedTextHtml,
} from "./word_utils";
import { parseHtmlText, parseJson, toAnyString } from "./message_utils";
import * as ce from "./custom_errors";
import { getWorkflowTotalTopicSteps } from "./llm_utils";
import { translate } from "../locales/i18n";
import { getSavedSelection, SavedSelection } from "../utils/session_storage_utils";
import {
  createTrafficLightResultObject,
  TrafficLightResultObject,
  ClauseReview,
  TrafficLighSummary,
} from "../utils/traffic_light_utils";
import { isElementVisibleInContainer } from "./html_utils";
import { TaskCategory } from "../utils/task_utils";
import { getFilteredWorkflowsCheck } from "./taskpane_utils";
import { runOfficeTask } from "./queue_utils";

import { marked } from "marked";
import DOMPurify from "dompurify";

export const colorStyleArray: string[] = ["green", "yellow", "red"];
export type ColorStyle = (typeof colorStyleArray)[number];

type SelectType = LLMStreamEventType | "all" | "user_all" | "assistant_all";

// TODO: find solution for different message display with base edit-document workflow
const _editDocumentBaseWorkflowsProd: string[] = ["b2a2989b-346d-423e-b400-698532a1d1a1"];
const _editDocumentBaseWorkflowsDev: string[] = ["b0b02032-0cd9-4ba4-978f-e59eda00483d"];
const editDocumentBaseWorkflows: string[] = _editDocumentBaseWorkflowsProd.concat(
  _editDocumentBaseWorkflowsDev
);
const editDocumentBaseTopics = ["Dokument überarbeiten"];

// const _trafficLightWorkflowsProdOLD: string[] = [
//   "84c05afe-c4aa-44d3-b095-5abf3612f828",
//   "58fae645-12ed-465a-8452-b4686a75faa3",
//   "595bea15-1e3a-46b5-9fc7-e8275c9c1512",
// ];
// const _trafficLightWorkflowsDevOLD: string[] = ["dee1567b-63f6-473f-bb03-61eb91176c3d"];
// const trafficLightWorkflowsOLD: string[] = _trafficLightWorkflowsProdOLD.concat(
//   _trafficLightWorkflowsDevOLD
// );

// const _trafficLightWorkflowsProd: string[] = [
//   "120a39fa-2e61-4db0-a4ca-9c4563a46d3e",
//   "67468748-791b-48d2-8451-4786eb7c0c89",
// ];
// const _trafficLightWorkflowsDev: string[] = ["eff3b8e9-82a0-4739-8a5f-dfaff2aef6a6"];
// export const trafficLightWorkflows: string[] =
//   _trafficLightWorkflowsProd.concat(_trafficLightWorkflowsDev);

let trafficLightWorkflows: string[] = [];

export function navBack(): void {
  const previousPage = localStorage.getItem("previousPage");
  document.location.href = previousPage ? previousPage : "menu.html";
}

export function navMenu(): void {
  if (document.location.href.includes("menu.html") || document.location.href.includes("login.html"))
    return;
  document.location.href = "menu.html";
}

function formatTimestamp(date: Date): string {
  return date.toLocaleString("de-AT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

function colorStyleToRGB(colorStyle: ColorStyle): string {
  switch (colorStyle) {
    case "green":
      return "rgb(34, 140, 34)";
    case "yellow":
      return "rgb(255, 204, 0)";
    case "red":
      return "rgb(223, 35, 32)";
    default:
      return "rgb(0, 0, 0)";
  }
}

let globalMainContainer: HTMLDivElement | null = null;
let trafficLightSubTopicOpenOk: boolean = true;

export class IOMain {
  public mainContainer: HTMLDivElement; // main IO container from the currently disyplayed page
  public optionsControl: IOMainOptionsControl | null; // options control for the main IO container
  private topicHeaderList: LLMMessageTopicContainer[] = []; // all topic containers in the main container
  private messageContainers: LLMMessageContainer[] = []; // all message containers in the main container
  private basicMessageContainers: BasicMessageContainer[] = []; // all basic message containers in the main container
  public currentMessageContainer: LLMMessageContainer; // the currently active message container
  private currentTopic: string = ""; // the current topic of the conversation
  public activeSearchTopic: LLMMessageTopicContainer | null = null; // the currently active search topic container
  public indicatorStart: NodeJS.Timeout | null = null;
  public indicatorWaitingForAnswer: NodeJS.Timeout | null = null;
  private currentMessageCompletionDebounce: NodeJS.Timeout | null = null;
  public taskCategory: TaskCategory;
  private currentPlaybookMessage: string = "";
  public messageCounter: number = 0;

  private currentWorkflowId: string = "";
  private currentworkflowUseTrafficLights: boolean = false;
  private currentTrafficLightSectionContainer: HTMLDivElement | null = null;
  private trafficLightEntryList: LLMMessageTopicContainer[] = [];
  private currentTrafficLightEntryContainer: LLMMessageTopicContainer | null = null;
  private lastMessageType: LLMStreamEventType | null = null;
  private workflowTrafficMessageCounter = 0;
  private currentTrafficLightSummary: TrafficLighSummary | null = null;

  private workflows: Workflow[] = [];
  private currentWorkflowTopicSteps: Record<string, number> = {};
  private topicHeaderProgressCounter: number = 0;
  private buttonCollapseAllTrafficLight: HTMLButtonElement;

  private goDownFAB: HTMLButtonElement;

  constructor(mainContainer: HTMLDivElement, taskCategory: TaskCategory, filterOn: boolean = true) {
    this.mainContainer = mainContainer;
    globalMainContainer = mainContainer;

    this.taskCategory = taskCategory;
    getWorkflows()
      .getWorkflows()
      .then((workflows) => {
        this.workflows = workflows;
        trafficLightWorkflows = getFilteredWorkflowsCheck(this.workflows).map(
          (workflow) => workflow.id
        );
      })
      .catch((error) => {
        console.error("Error getting workflows: ", error);
      });

    this.optionsControl = new IOMainOptionsControl(this.onFilterChangeAll.bind(this));
    this.currentMessageContainer = new LLMMessageContainer(
      {
        // server: "n/a",
        category: "chat",
        type: "heartbeat",
        content: "",
        role: "assistant",
        model: "n/a",
        timestamp: 0,
      },
      undefined,
      this.taskCategory
    ); // ewww

    this.mainContainer.id = "llm-main-message-container";

    this.goDownFAB = document.createElement("button");
    this.goDownFAB.classList.add("fab", "hidden");
    this.goDownFAB.innerHTML =
      '<span role="img" aria-label="arrow-down" tabindex="-1" class="anticon anticon-arrow-down arrow"><svg focusable="false" class="" data-icon="arrow-down" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"></path></svg></span>';
    this.goDownFAB.title = translate("scroll-down");
    this.goDownFAB.onclick = () => {
      this.scrollDown(true);
      this.goDownFAB.classList.add("hidden");
    };
    this.mainContainer.appendChild(this.goDownFAB);

    this.mainContainer.addEventListener("scroll", () => this.scrollHandler());

    // maybe rework main options control
    this.optionsControl.root().classList.add("gone");

    if (filterOn && this.optionsControl) {
      this.mainContainer.parentNode
        ? this.mainContainer.parentNode.insertBefore(this.optionsControl.root(), this.mainContainer)
        : null; // should never happen, throw error?
    }

    // collapse all traffic light entries
    this.buttonCollapseAllTrafficLight = document.createElement("button");
    this.buttonCollapseAllTrafficLight.type = "button";
    this.buttonCollapseAllTrafficLight.classList.add("btn");
    const collapseAllText = translate("collapse-all");
    this.buttonCollapseAllTrafficLight.textContent = collapseAllText;
    this.buttonCollapseAllTrafficLight.title = collapseAllText;
    this.buttonCollapseAllTrafficLight.onclick = () => {
      this.trafficLightEntryList.forEach((entry) => {
        entry.clauseSubTopicEntries.forEach((subEntry) => {
          subEntry.subTopicClose();
        });
        entry.topicClose();
        entry.trafficLightSummary?.resetAllSubTopicNavigation();
      });
      this.goDownFAB.click();
    };
  }

  public setTrafficLightSubTopicOpenOk(ok: boolean) {
    trafficLightSubTopicOpenOk = ok;
  }

  public scrollHandler() {
    const { scrollTop, scrollHeight, clientHeight } = this.mainContainer;
    const distanceToBottom = scrollHeight - scrollTop - clientHeight;
    autoScroll = distanceToBottom <= 100;

    if (!autoScroll) {
      this.goDownFAB.classList.remove("hidden");
    } else {
      this.goDownFAB.classList.add("hidden");
    }

    this.goDownFAB.style.bottom = `${10 - scrollTop}px`;
  }

  public messageRequestDone() {
    if (this.indicatorWaitingForAnswer) {
      hideLoadingIndicator(this.mainContainer, this.indicatorWaitingForAnswer);
      this.indicatorWaitingForAnswer = null;
    }

    resetWordImageMap();

    this.currentWorkflowId = "";
    this.currentworkflowUseTrafficLights = false;
    this.topicHeaderProgressCounter = 0;
    try {
      const headerProgressContainer = document.getElementById(
        "progress-container"
      ) as HTMLDivElement;

      headerProgressContainer.innerHTML = "";

      if (this.trafficLightEntryList.length > 0) {
        headerProgressContainer.appendChild(this.buttonCollapseAllTrafficLight);
      }
    } catch (error) {}

    const savedSelection = getSavedSelection(this.taskCategory);
    if (savedSelection !== null) {
      this.currentMessageContainer.showReplaceLastSelectionButton(savedSelection);
    }

    this.currentTrafficLightEntryContainer?.trafficLightSummary?.clearAllCardAddCount();

    if (this.trafficLightEntryList.length > 0) {
      this.trafficLightEntryList[this.trafficLightEntryList.length - 1].completeTrafficLightEntry({
        content: "",
      });
    }
  }

  public clearCurrentMessageContainerReplaceLastSelectionButton() {
    this.currentMessageContainer.hideReplaceLastSelectionButton();
  }

  public async addTopicContainer(topic: string, useTrafficLights: boolean = false) {
    if (useTrafficLights) {
      this.currentTrafficLightEntryContainer = new LLMMessageTopicContainer(
        topic,
        this.setActiveSearchTopic.bind(this),
        this.taskCategory,
        useTrafficLights,
        undefined,
        null,
        this.currentTrafficLightSummary
      );
      // this.topicHeaderList.push(topicHeaderTraffic);
      this.currentTrafficLightSectionContainer?.appendChild(
        this.currentTrafficLightEntryContainer.root()
      );
      this.trafficLightEntryList.push(this.currentTrafficLightEntryContainer);
      return;
    }

    const topicHeader = new LLMMessageTopicContainer(
      topic,
      this.setActiveSearchTopic.bind(this),
      this.taskCategory
    );
    this.topicHeaderList.push(topicHeader);
    this.mainContainer.appendChild(topicHeader.root());
    // this.optionsControl?.addSelectTopic(this.currentTopic);
  }

  private accumulatedAssistantText = "";
  private lastRole: "user" | "assistant" | null = null;

  private insertAccordionSorted(accordion: HTMLElement, startTime: Date): void {
    const existingAccordions = Array.from(this.workflowAccordions.values());

    // Find the correct insertion position (oldest first)
    let insertBeforeElement: HTMLElement | null = null;

    for (const [runId, existingAccordion] of this.workflowAccordions.entries()) {
      const existingTime = new Date(existingAccordion.dataset.workflowStartTime || 0);

      // If the new accordion is older than this one, insert before it
      if (startTime < existingTime) {
        insertBeforeElement = existingAccordion;
        break;
      }
    }

    if (insertBeforeElement) {
      this.mainContainer.insertBefore(accordion, insertBeforeElement);
    } else {
      // If no element found or it's the newest, append at the end
      this.mainContainer.appendChild(accordion);
    }
  }
  public async addLLMIO(
    llmMessage: IOMainLLMMessage,
    overwriteTaskCategory: TaskCategory | null = null,
    workflowRunId?: string,
    workflowName?: string,
    workflowStartTime?: Date
  ) {
    if (overwriteTaskCategory) {
      this.taskCategory = overwriteTaskCategory;
    }

    if (llmMessage.isHistoryLoading && workflowRunId) {
      let targetContainer: HTMLElement;

      if (this.workflowAccordions.has(workflowRunId)) {
        // Accordion already exists, get its content container
        const accordion = this.workflowAccordions.get(workflowRunId)!;
        targetContainer = accordion.querySelector(
          `.workflow-accordion-content[data-workflow-run-id="${workflowRunId}"]`
        )!;
      } else {
        // Create new accordion
        const accordion = this.createWorkflowAccordion(
          workflowRunId,
          workflowName || "Unknown Workflow",
          workflowStartTime || new Date()
        );
        this.workflowAccordions.set(workflowRunId, accordion);

        this.insertAccordionSorted(accordion, workflowStartTime || new Date());

        targetContainer = accordion.querySelector(
          `.workflow-accordion-content[data-workflow-run-id="${workflowRunId}"]`
        )!;

        this.currentTrafficLightSectionContainer = null;
        this.currentTrafficLightEntryContainer = null;
        this.currentWorkflowId = undefined;
      }

      // Temporarily replace mainContainer for this message
      const originalMainContainer = this.mainContainer;
      this.mainContainer = targetContainer;

      // Continue with existing logic...
      await this.addLLMIOInternal(llmMessage);

      // Restore original container
      this.mainContainer = originalMainContainer;
      return;
    }

    // Messages without workflow go to non-workflow section
    if (llmMessage.isHistoryLoading && !workflowRunId) {
      const targetContainer = this.getOrCreateNonWorkflowContainer();
      const originalMainContainer = this.mainContainer;
      this.mainContainer = targetContainer;

      await this.addLLMIOInternal(llmMessage);

      this.mainContainer = originalMainContainer;
      return;
    }

    // Normal flow for non-history messages
    await this.addLLMIOInternal(llmMessage);
  }
  public async addLLMIOInternal(
    llmMessage: IOMainLLMMessage,
    overwriteTaskCategory: TaskCategory | null = null
  ) {
    if (overwriteTaskCategory) {
      this.taskCategory = overwriteTaskCategory;
    }
    this.taskCategory === "traffic-light";
    const roleSwitched = this.lastRole !== null && this.lastRole !== llmMessage.role;
    if (this.lastMessageType !== llmMessage.type) this.messageCounter++;

    if (this.taskCategory === "playbook") {
      if (llmMessage.role === "user") {
        if (this.indicatorStart) {
          hideLoadingIndicator(this.mainContainer, this.indicatorStart);
          this.indicatorStart = null;
        }
        console.log("user message, show Loading Indicator");
        this.indicatorWaitingForAnswer = showLoadingIndicator(
          this.mainContainer,
          "Ihre Anfrage wird bearbeitet. Dies kann bis zu 60 Sekunden dauern."
        );
        //  console.log("returning because user");
        return;
      }
      this.currentPlaybookMessage += llmMessage.content;
      console.log("retruhning because playbook");
      //   return;
    }

    // TODO: REMOVE AFTER TESTING
    // llmMessage.workflowId = "TEST";
    // TODO: REMOVE AFTER TESTING
    if (this.taskCategory === "traffic-light" && !llmMessage.workflowId) {
      llmMessage.workflowId = trafficLightWorkflows[0]; // default to first traffic light workflow
    }

    if (llmMessage.workflowId && llmMessage.workflowId !== this.currentWorkflowId) {
      this.currentWorkflowId = llmMessage.workflowId;
      this.currentworkflowUseTrafficLights =
        this.currentWorkflowId !== undefined &&
        trafficLightWorkflows.includes(this.currentWorkflowId);

      // TODO: REMOVE AFTER TESTING
      // this.currentworkflowUseTrafficLights = true;
      // TODO: REMOVE AFTER TESTING

      if (this.currentworkflowUseTrafficLights) {
        this.currentTrafficLightSectionContainer = document.createElement("div");
        this.currentTrafficLightSectionContainer.classList.add(
          "traffic-light-section-container",
          "flex",
          "flex-col"
        );

        this.currentTrafficLightSummary = new TrafficLighSummary();
        this.currentTrafficLightSectionContainer.appendChild(
          this.currentTrafficLightSummary.root()
        );

        this.mainContainer.appendChild(this.currentTrafficLightSectionContainer);
      }

      const currentWorkflow = this.workflows.find(
        (workflow) => workflow.id === this.currentWorkflowId
      );
      if (currentWorkflow) {
        this.currentWorkflowTopicSteps = getWorkflowTotalTopicSteps(currentWorkflow);
        console.log("workflowtotaltopicsteps", this.currentWorkflowTopicSteps);
      }
    }

    if (this.lastMessageType !== llmMessage.type) {
      const wasAssistantMessage =
        this.lastMessageType && this.lastMessageType.includes("assistant");

      if (wasAssistantMessage && llmMessage.role === "user") {
        console.log("switching from assistant to user ");

        this.currentTrafficLightEntryContainer?.completeTrafficLightEntry(llmMessage);
      }

      // user / assistant change - create new message container
      if (llmMessage.topic && llmMessage.topic !== this.currentTopic) {
        this.currentTopic = llmMessage.topic;
        if (this.taskCategory !== "edit-document") {
          this.addTopicContainer(this.currentTopic, this.currentworkflowUseTrafficLights);
        }
        this.workflowTrafficMessageCounter = 0;

        // workflow traffic light progress
        if (
          this.currentTrafficLightEntryContainer !== null &&
          this.currentworkflowUseTrafficLights
        ) {
          this.topicHeaderProgressCounter++;
          try {
            const headerProgressContainer = document.getElementById(
              "progress-container"
            ) as HTMLDivElement;
            headerProgressContainer.innerHTML = "";
            const progressSpan = document.createElement("span");
            progressSpan.textContent = `${translate("progress")}: ${this.topicHeaderProgressCounter} / ${Object.keys(this.currentWorkflowTopicSteps).length}`;
            headerProgressContainer.appendChild(progressSpan);
          } catch (error) {
            console.log("NEW AERROR");
          }
        }
      }
    }

    if (this.currentTrafficLightEntryContainer !== null && this.currentworkflowUseTrafficLights) {
      // workflow traffic light
      if (this.indicatorStart) {
        console.log("hide indicator in wierd check");
        hideLoadingIndicator(this.mainContainer, this.indicatorStart);
        this.indicatorStart = null;
      }

      if (this.lastMessageType !== llmMessage.type) {
        this.lastMessageType = llmMessage.type;

        if (llmMessage.role === "assistant") {
          //Create new traffic light entry and add initial message to it
          if (this.indicatorWaitingForAnswer) {
            hideLoadingIndicator(this.mainContainer, this.indicatorWaitingForAnswer);
            this.indicatorWaitingForAnswer = null;
          }
          this.currentTrafficLightEntryContainer.createTrafficLightEntry(
            llmMessage,
            this.currentWorkflowTopicSteps
          );

          this.currentTrafficLightEntryContainer.addToTrafficLightEntry(llmMessage);
          console.log("message type is assistant, waiting for answer ");
          this.indicatorWaitingForAnswer = showLoadingIndicator(this.mainContainer, "...");
        }
      } else {
        // same user / assistant - add text to current message container
        if (llmMessage.role === "assistant") {
          // console.log("addToTrafficLightEntry in addLLMIO", llmMessage);
          //add to existing traffic light entry
          this.currentTrafficLightEntryContainer.addToTrafficLightEntry(llmMessage);
        }
      }
    } else {
      // non traffic light messages
      if (this.lastMessageType !== llmMessage.type) {
        // message type changed - new message

        // check last complete message content
        if (this.currentMessageContainer.rawText.trim() === "") {
          // maybe different behavior for other task-categories?
          this.currentMessageContainer.replaceText(this.currentMessageContainer.topic);
        }

        this.lastMessageType = llmMessage.type;

        // different conditions to hide / filter message container
        // workflow_ids are only set client side
        // for message history loading we need to identify by topic...
        // TODO: check after changes to workflow structure
        // const hideEditDocumentContainer =
        //   this.taskCategory === "edit-document" &&
        //   ((llmMessage.workflowId !== undefined &&
        //     editDocumentBaseWorkflows.includes(llmMessage.workflowId)) ||
        //     (llmMessage.topic !== undefined &&
        //       editDocumentBaseTopics.includes(llmMessage.topic))) &&
        //   (this.messageCounter === 2 || this.messageCounter === 3);
        // const hideContainer = hideEditDocumentContainer;
        const hideContainer = false;

        this.currentMessageContainer = new LLMMessageContainer(
          llmMessage,
          false,
          this.taskCategory,
          hideContainer
        );
        this.messageContainers.push(this.currentMessageContainer);
        this.mainContainer.appendChild(this.currentMessageContainer.root());

        this.optionsControl?.addSelectType(llmMessage.type);

        // apply filter to new message container
        this.onFilterChangeAll();

        if (llmMessage.role === "user") {
          // new user message (prompt)
          if (this.indicatorStart) {
            console.log("user message, hiding start indicator");
            hideLoadingIndicator(this.mainContainer, this.indicatorStart);
            this.indicatorStart = null;
          }
          if (!llmMessage.isHistoryLoading) {
            console.log("user message and history not loading, show indicator");
            this.indicatorWaitingForAnswer = showLoadingIndicator(
              this.mainContainer,
              "Ihre Anfrage wird bearbeitet. Dies kann bis zu 60 Sekunden dauern."
            );
          }
        } else if (llmMessage.role === "assistant") {
          // new assistant message (answer) was created
          if (this.indicatorWaitingForAnswer) {
            console.log("assistant message, hide waiting for answer indicatror");
            hideLoadingIndicator(this.mainContainer, this.indicatorWaitingForAnswer);
            this.indicatorWaitingForAnswer = null;
          }
          this.workflowTrafficMessageCounter++;

          // find a better way to check for specific workflows
          // if (
          //   this.taskCategory === "edit-document" &&
          //   ((llmMessage.workflowId !== undefined &&
          //     editDocumentBaseWorkflows.includes(llmMessage.workflowId) &&
          //     this.messageCounter === 4) ||
          //     (llmMessage.workflowId !== undefined &&
          //       !editDocumentBaseWorkflows.includes(llmMessage.workflowId) &&
          //       this.messageCounter === 2))
          // )
          // TODO: check if still needed
          // if (
          //   this.taskCategory === "edit-document" &&
          //   llmMessage.workflowId !== undefined &&
          //   editDocumentBaseWorkflows.includes(llmMessage.workflowId) &&
          //   (this.messageCounter === 2 || this.messageCounter === 4)
          // ) {
          //   this.indicatorWaitingForAnswer = showLoadingIndicator(
          //     this.mainContainer,
          //     "Das geänderte Dokument wird gesamelt und aufgebaut. Bitte warten."
          //   );
          // }
        }
      } else {
        // same user / assistant message - add text to current message container
        if (llmMessage.role === "user") {
          if (this.taskCategory !== "edit-document") {
            await this.currentMessageContainer.addText(llmMessage.content);
          }
        }
        if (llmMessage.role === "assistant") {
          await this.currentMessageContainer.addText(llmMessage.content);
        }
      }
    }

    if (llmMessage.isHistoryLoading !== undefined && llmMessage.isHistoryLoading) {
      this.currentMessageContainer.metadataControl.showAll();
      return;
    }

    if (autoScroll) {
      this.scrollDown();
    }
  }

  private workflowAccordions: Map<string, HTMLElement> = new Map();
  private nonWorkflowMessagesContainer: HTMLElement | null = null;
  // Add new method to create workflow accordion

  private createWorkflowAccordion(
    workflowRunId: string,
    workflowName: string,
    startTime: Date
  ): HTMLElement {
    const accordionContainer = document.createElement("div");
    accordionContainer.classList.add("workflow-accordion", "flex", "flex-col");
    accordionContainer.dataset.workflowRunId = workflowRunId;

    // ✅ STORE TIMESTAMP FOR SORTING
    accordionContainer.dataset.workflowStartTime = startTime.toISOString();

    const accordionHeader = document.createElement("div");
    accordionHeader.classList.add(
      "workflow-accordion-header",
      "flex",
      "flex-row",
      "flex-content-between"
    );

    const headerText = document.createElement("div");

    headerText.innerHTML = `
    <strong>${workflowName}</strong>
    <span class="text-gray-600 ml-2">${formatTimestamp(startTime)}</span>
  `;

    const chevron = document.createElement("div");
    chevron.innerHTML = `
    <div class="flex flex-row flex-content-between">
      <button class="toggle-button"><span class="triangle"></span></button>
    </div>
  `;

    const spacer = document.createElement("div");
    spacer.classList.add("spacer", "flex-grow");

    accordionHeader.appendChild(headerText);
    accordionHeader.appendChild(spacer);
    accordionHeader.appendChild(chevron);

    const accordionContent = document.createElement("div");
    accordionContent.classList.add("workflow-accordion-content", "flex-col", "collapse");
    accordionContent.dataset.workflowRunId = workflowRunId;

    accordionHeader.addEventListener("click", () => {
      accordionContent.classList.toggle("collapse");
      const isCollapsed = accordionContent.classList.contains("collapse");
      chevron.innerHTML = `<div class="flex flex-row flex-content-between"><button class="toggle-button ${isCollapsed ? "" : "open"}"><span class="triangle"></span></button></div>`;
    });

    accordionContainer.appendChild(accordionHeader);
    accordionContainer.appendChild(accordionContent);

    return accordionContainer;
  }

  // Add method to get or create non-workflow container
  private getOrCreateNonWorkflowContainer(): HTMLElement {
    if (!this.nonWorkflowMessagesContainer) {
      this.nonWorkflowMessagesContainer = document.createElement("div");
      this.nonWorkflowMessagesContainer.classList.add("non-workflow-messages", "mt-4");

      const header = document.createElement("h3");
      header.textContent = "Andere Nachrichten";
      header.classList.add("font-bold", "mb-2");

      this.nonWorkflowMessagesContainer.appendChild(header);
      this.mainContainer.appendChild(this.nonWorkflowMessagesContainer);
    }
    return this.nonWorkflowMessagesContainer;
  }

  public async playbookMessageEnd() {
    try {
      if (this.indicatorWaitingForAnswer) {
        console.log("playbookmessageend, hide indicator)");
        hideLoadingIndicator(this.mainContainer, this.indicatorWaitingForAnswer);
        this.indicatorWaitingForAnswer = null;
      }

      const msg = this.currentPlaybookMessage;

      if (msg.match(/keine\s.*\sklauseln\sgefunden/gi)) {
        const basicMessage: IOBasicMessage = { text: msg, role: "option" };
        this.addBasicMessage(basicMessage);
        return;
      }

      let cleaned = msg.replace(/^```json\s*|\s*```$/g, "");
      if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
        cleaned = cleaned.slice(1, -1);
      }
      const parsed = JSON.parse(cleaned);
      const topics = Object.keys(parsed);
      topics.forEach((topic) => {
        this.addTopicContainer(topic);
        const messageIndices = Object.keys(parsed[topic]);
        messageIndices.forEach((index) => {
          const message = parsed[topic][index];
          const basicMessage: IOBasicMessage = { text: message, role: "option" };
          this.addBasicMessage(basicMessage);
        });
      });
    } catch (error) {
      console.error(error);
      toastMessage(
        "Die Antwort Ihrer Anfrage konnte nicht interpretiert werden. Bitter versuchen Sie es erneut.",
        "error"
      );
    } finally {
      this.currentPlaybookMessage = "";
    }
  }

  public resetMessageCounter() {
    this.messageCounter = 0;
  }

  public async addBasicMessage(message: IOBasicMessage) {
    const basicMessageContainer = new BasicMessageContainer(message);
    basicMessageContainer.metadataControl.showAll();
    this.basicMessageContainers.push(basicMessageContainer);
    this.mainContainer.appendChild(basicMessageContainer.root());

    this.scrollHandler();
  }

  private getLastMessageElement(): HTMLElement | null {
    // if (this.messageContainers.length > 0) {
    //   return this.messageContainers[this.messageContainers.length - 1].root();
    // } else if (this.basicMessageContainers.length > 0) {
    //   return this.basicMessageContainers[this.basicMessageContainers.length - 1].root();
    // }
    // return null;

    return this.mainContainer.lastElementChild
      ? (this.mainContainer.lastElementChild as HTMLElement)
      : null;
  }

  public scrollDown(force: boolean = false) {
    const downTarget = this.getLastMessageElement();
    scrollToTargetSmooth(downTarget ? downTarget : this.mainContainer, force);
  }

  public clearAllMessages() {
    this.messageContainers.forEach((messageContainer) => {
      messageContainer.root().remove();
    });
    this.messageContainers = [];
    this.basicMessageContainers.forEach((basicMessageContainer) => {
      basicMessageContainer.root().remove();
    });
    this.basicMessageContainers = [];
    this.topicHeaderList.forEach((topicHeader) => {
      topicHeader.root().remove();
    });
    this.topicHeaderList = [];
    this.currentMessageContainer = new LLMMessageContainer(
      {
        // server: "n/a",
        category: "chat",
        type: "heartbeat",
        content: "",
        role: "assistant",
        model: "n/a",
        timestamp: 0,
      },
      undefined,
      this.taskCategory
    ); // ewww
  }

  private onFilterChangeAll() {
    const selectedType = this.optionsControl?.getSelectedType();
    const selectedTopic = this.optionsControl?.getSelectedTopic();

    this.messageContainers.forEach((messageContainer) => {
      const typeMatches =
        selectedType === "all" ||
        (selectedType === "user_all" && messageContainer.getRole() === "user") ||
        (selectedType === "assistant_all" && messageContainer.getRole() === "assistant") ||
        messageContainer.getType() === selectedType;

      const topicMatches = selectedTopic === "all" || messageContainer.topic === selectedTopic;

      if (typeMatches && topicMatches) {
        messageContainer.root().style.display = "block";
      } else {
        messageContainer.root().style.display = "none";
      }
    });

    this.topicHeaderList.forEach((topicHeader) => {
      if (selectedTopic === "all" || topicHeader.topic === selectedTopic) {
        topicHeader.root().style.display = "flex";
      } else {
        topicHeader.root().style.display = "none";
      }
    });
  }

  public applyTaskFilter(taskCategory: TaskCategory) {
    if (
      taskCategory === "summarize" ||
      taskCategory === "playbook" ||
      taskCategory === "workflow"
    ) {
      this.optionsControl?.setTypeSelection("assistant_all");
    }
    this.optionsControl?.updateFilter();
  }

  public hideAllLoadingIndicators() {
    console.log("hide all indicators");
    hideLoadingIndicator(this.mainContainer, this.indicatorStart);
    this.indicatorStart = null;
    hideLoadingIndicator(this.mainContainer, this.indicatorWaitingForAnswer);
    this.indicatorWaitingForAnswer = null;
  }

  private async setActiveSearchTopic(topic: LLMMessageTopicContainer): Promise<void> {
    if (this.activeSearchTopic) {
      await this.activeSearchTopic.deactivate();
    }
    this.activeSearchTopic = topic;
    // this.activeSearchTopic.setSearchRanges(await searchTextRanges(topic.topic, true, 0));
    this.activeSearchTopic.setSearchRanges(await searchTextinDocument(topic.topic, true, 0));
  }

  public grow() {
    // requestAnimationFrame(() => {
    //   this.mainContainer.classList.remove("border-separator-top-0", "border-separator-bottom-0");
    //   requestAnimationFrame(() => {
    //     this.mainContainer.classList.add("border-separator-top", "border-separator-bottom");
    //     this.mainContainer.classList.add("flex-grow");
    //   });
    // });

    this.mainContainer.classList.remove("border-separator-top-0", "border-separator-bottom-0");
    this.mainContainer.classList.add("border-separator-top", "border-separator-bottom");
    // this.mainContainer.classList.add("flex-grow");
    this.mainContainer.style.height = "100%";
  }
}

class IOMainOptionsControl {
  private container: HTMLDivElement; // container for the options control

  private labelSelectContainer: HTMLDivElement; // container for the label select

  private labelContainer: HTMLDivElement; // container for the label
  private optionSelectContainer: HTMLDivElement; // container for the option selecton
  private optionMenuContainer: HTMLDivElement; // container for the option menu

  private labelType: HTMLLabelElement; // label for the message type
  private labelTopic: HTMLLabelElement; // label for the message

  private selectType: HTMLSelectElement; // select for the message type
  private selectTypeGroupPrompt: HTMLOptGroupElement; // optgroup for the message prompts
  private selectTypeGroupAnswer: HTMLOptGroupElement; // optgroup for the message answers

  private selectTopic: HTMLSelectElement; // select for the message topic

  private menuItemFilter: HTMLButtonElement; // button to filter the messages

  constructor(onFilterChangeCallback: () => void) {
    this.container = document.createElement("div");

    this.labelSelectContainer = document.createElement("div");

    this.labelContainer = document.createElement("div");
    this.optionSelectContainer = document.createElement("div");
    this.optionMenuContainer = document.createElement("div");

    this.labelType = document.createElement("label");
    this.labelTopic = document.createElement("label");

    this.selectType = document.createElement("select");
    this.selectTypeGroupPrompt = document.createElement("optgroup");
    this.selectTypeGroupAnswer = document.createElement("optgroup");

    this.selectTopic = document.createElement("select");

    this.menuItemFilter = document.createElement("button");

    // ########################################################################

    this.container.id = "llm-message-options-control";

    this.labelSelectContainer.id = "llm-message-options-label-select-container";
    this.labelSelectContainer.classList.add("collapse");

    this.labelContainer.id = "llm-message-options-label";
    this.labelContainer.classList.add("options-col");

    this.optionSelectContainer.id = "llm-message-options-select";
    this.optionSelectContainer.classList.add("options-col");

    this.optionMenuContainer.id = "llm-message-options-menu";
    this.menuItemFilter.classList.add("menu-item");

    this.container.appendChild(this.labelSelectContainer);
    this.container.appendChild(this.optionMenuContainer);

    this.labelSelectContainer.appendChild(this.labelContainer);
    this.labelSelectContainer.appendChild(this.optionSelectContainer);

    this.labelContainer.appendChild(this.labelType);
    this.labelContainer.appendChild(this.labelTopic);

    this.optionSelectContainer.appendChild(this.selectType);
    this.optionSelectContainer.appendChild(this.selectTopic);

    this.optionMenuContainer.appendChild(this.menuItemFilter);

    // ########################################################################

    this.menuItemFilter.innerHTML = '<i class="fa fa-filter"></i>';
    this.menuItemFilter.title = "Nachrichten filtern";
    this.menuItemFilter.onclick = () => {
      if (this.labelSelectContainer.clientHeight === 0) {
        this.labelSelectContainer.style.maxHeight = this.labelSelectContainer.scrollHeight + "px";
      } else {
        this.labelSelectContainer.style.maxHeight = "0";
      }
      this.optionMenuContainer.classList.toggle("nudge");
    };

    this.labelType.textContent = "Typ";
    this.labelTopic.textContent = "Thema";

    this.selectType.add(new Option("Alle Inhalte", "all"));
    this.selectType.appendChild(this.selectTypeGroupPrompt);
    this.selectType.appendChild(this.selectTypeGroupAnswer);
    this.selectTypeGroupPrompt.label = "Prompts";
    this.selectTypeGroupAnswer.label = "Antworten";

    this.selectTypeGroupPrompt.appendChild(new Option("Alle Prompts", "user_all"));
    this.selectTypeGroupAnswer.appendChild(new Option("Alle Antworten", "assistant_all"));

    this.selectTopic.add(new Option("Alle Themen", "all"));

    // ########################################################################

    this.selectType.onchange = onFilterChangeCallback;
    this.selectTopic.onchange = onFilterChangeCallback;

    this.checkFilterLength(this.labelType, this.selectType);
    this.checkFilterLength(this.labelTopic, this.selectTopic);
  }

  public root(): HTMLDivElement {
    return this.container;
  }

  public getSelectedType(): SelectType {
    return this.selectType.value as SelectType;
  }

  public getSelectedTopic(): string {
    return this.selectTopic.value;
  }

  public addSelectType(type: LLMStreamEventType) {
    try {
      if (this.selectType.querySelector(`option[value="${type}"]`)) return;
      const { role, category } = LLMTypeToRoleAndCategory[type];
      const option = new Option(LLMMessageCategoryToDisplayType[category], type);
      option.title = LLMMessageCategoryToDisplayType[category];
      if (role === "user") {
        this.selectTypeGroupPrompt.appendChild(option);
      } else if (role === "assistant") {
        this.selectTypeGroupAnswer.appendChild(option);
      }
      this.checkFilterLength(this.labelType, this.selectType);
    } catch (error) {}
  }

  public addSelectTopic(topic: string) {
    if (this.selectTopic.querySelector(`option[value="${topic}"]`)) return;
    const option = new Option(topic, topic);
    option.title = topic;
    this.selectTopic.add(option);
    this.checkFilterLength(this.labelTopic, this.selectTopic);
  }

  public setTypeSelection(selectType: SelectType) {
    if (this.selectType.querySelector(`option[value="${selectType}"]`)) {
      this.selectType.value = selectType;
      this.updateFilter();
    }
  }

  public updateFilter() {
    this.selectType.dispatchEvent(new Event("change"));
    this.selectTopic.dispatchEvent(new Event("change"));
  }

  private checkFilterLength(label: HTMLLabelElement, select: HTMLSelectElement) {
    if (select.options.length > 1) {
      label.style.display = "block";
      select.style.display = "block";
    } else {
      label.style.display = "none";
      select.style.display = "none";
    }
  }
}

export class LLMMessageTopicContainer {
  public topicMainContainer: HTMLDivElement;
  private containerHeader: HTMLDivElement;
  private container: HTMLDivElement; // container for the llm message topic
  public trafficLightContainer: HTMLDivElement;

  private header: HTMLParagraphElement; // the header for the llm message topic
  public topic: string; // the topic of the llm message
  private topicStrong: HTMLElement; // the strong element for the topic in the header
  private searchIcon: HTMLDivElement;
  private searchControlContainer: HTMLDivElement; // container for the search control
  private searchPreviousButton: HTMLButtonElement; // button to search for the previous occurence of the topic
  private searchNextButton: HTMLButtonElement; // button to search for the next occurence of the topic
  private searchCancelButton: HTMLButtonElement; // button to cancel the search for the topic
  private searchResCount: number = 0; // number of search occurences
  private currentSearchIndex: number = 0; // index of the current search occurence

  private taskCategory: TaskCategory;
  public statusLight: HTMLDivElement;
  private statusIsGreen: boolean = false;
  private initialStatusColorSet: boolean = false;
  public toggleTrafficButton: HTMLButtonElement;
  private trafficButtonTriangle: HTMLSpanElement;
  public useTrafficLights: boolean = false;
  public trafficLightContentContainer: HTMLDivElement;
  public trafficLightContentWrapper: HTMLDivElement;
  private currentTrafficLightEntry: HTMLDivElement | null = null;
  private currentTrafficLightEntryTextRaw: string = "";
  private messageCounter: number = 0;
  private lastjsonFirstValue: string = "";
  private isSubContainer: boolean = false;
  public parentTopicContainer: LLMMessageTopicContainer | null = null;
  public clauseSubTopicEntries: LLMMessageTopicContainer[] = [];
  private deviationSubTopicEntries: LLMMessageTopicContainer[] = [];
  private missingSubTopicEntries: LLMMessageTopicContainer[] = [];

  public trafficLightSummary: TrafficLighSummary | null = null;
  private subTopicNavigationContainer: HTMLDivElement;
  private subTopicNavigationPreviousButton: HTMLButtonElement;
  private subTopicNavigationNextButton: HTMLButtonElement;
  private currentSubTopicIndex: number = -1;
  private currentSubTopicRelevantText: string = "";

  public setActiveSearchTopicFunction: (topic: LLMMessageTopicContainer) => Promise<void>;

  constructor(
    topic: string,
    setActiveSearchTopic: (topic: LLMMessageTopicContainer) => Promise<void>,
    taskCategory: TaskCategory,
    useTrafficLights: boolean = false,
    isSubContainer: boolean = false,
    statusUpdateCallback: (() => void) | null = null,
    trafficLightSummary: TrafficLighSummary | null = null,
    parentTopicContainer: LLMMessageTopicContainer | null = null
  ) {
    this.taskCategory = taskCategory;
    this.useTrafficLights = useTrafficLights;
    this.setActiveSearchTopicFunction = setActiveSearchTopic;
    this.isSubContainer = isSubContainer;
    this.trafficLightSummary = trafficLightSummary;
    this.parentTopicContainer = parentTopicContainer;

    this.topicMainContainer = document.createElement("div");
    this.containerHeader = document.createElement("div");
    this.container = document.createElement("div");
    this.trafficLightContainer = document.createElement("div");
    this.trafficLightContentContainer = document.createElement("div");
    this.trafficLightContentWrapper = document.createElement("div");

    this.header = document.createElement("p");
    this.topicStrong = document.createElement("strong");
    this.searchIcon = document.createElement("div");
    this.searchControlContainer = document.createElement("div");
    this.searchPreviousButton = document.createElement("button");
    this.searchNextButton = document.createElement("button");
    this.searchCancelButton = document.createElement("button");

    this.statusLight = document.createElement("div");
    this.toggleTrafficButton = document.createElement("button");
    this.trafficButtonTriangle = document.createElement("span");
    this.subTopicNavigationContainer = document.createElement("div");
    this.subTopicNavigationPreviousButton = document.createElement("button");
    this.subTopicNavigationNextButton = document.createElement("button");

    if (this.useTrafficLights) {
      if (this.isSubContainer) {
        this.topicMainContainer.classList.add("sub-topic-main-container", "flex", "flex-col");
        this.trafficLightContentWrapper.classList.add(
          "sub-traffic-light-content-wrapper",
          "flex",
          "flex-col"
        );
      } else {
        this.topicMainContainer.classList.add("topic-main-container-tl", "flex", "flex-col");
        this.trafficLightContentWrapper.classList.add("traffic-light-content-wrapper");
      }
      this.containerHeader.classList.add(
        "topic-header-container-tl",
        "flex",
        "flex-row",
        "flex-content-between"
      );
      this.container.classList.add(
        "topic-container",
        "flex",
        "flex-row",
        "flex-grow",
        "flex-content-between"
      );
    } else {
      this.topicMainContainer.classList.add("topic-main-container", "flex", "flex-col");
      this.containerHeader.classList.add(
        "topic-header-container",
        "flex",
        "flex-row",
        "flex-content-between"
      );
      this.container.classList.add(
        "topic-container",
        "flex",
        "flex-row",
        "flex-grow",
        "flex-content-start"
      );
    }

    // TODO: check if workflow or just traffic lights when moving logic to new page
    if (taskCategory === "workflow" || taskCategory === "traffic-light") {
      this.container.classList.remove("topic-container", "flex-grow");
      this.container.classList.add("topic-container-wf");
    }

    this.trafficLightContainer.classList.add(
      "traffic-light-status-container",
      "flex",
      "flex-row",
      "flex-content-between"
    );
    this.statusLight.classList.add("status-light");
    this.toggleTrafficButton.classList.add("toggle-button");
    this.trafficButtonTriangle.classList.add("triangle");
    this.trafficLightContentContainer.classList.add(
      "traffic-light-content-container",
      "flex",
      "flex-col",
      "collapse"
    );

    this.header.classList.add("topic-header");
    this.searchIcon.classList.add("topic-search-icon", "push-left");
    this.searchControlContainer.classList.add("topic-search-control-container", "flex", "flex-row");
    this.searchPreviousButton.classList.add("topic-search-button");
    this.searchNextButton.classList.add("topic-search-button");
    this.searchCancelButton.classList.add("topic-search-button");

    this.subTopicNavigationContainer.classList.add(
      "topic-search-control-container", // reuse
      "sub-topic-navigation-container",
      "flex",
      "flex-row"
    );
    this.subTopicNavigationPreviousButton.classList.add("topic-search-button");
    this.subTopicNavigationNextButton.classList.add("topic-search-button");

    this.topicMainContainer.appendChild(this.containerHeader);
    this.containerHeader.appendChild(this.container);

    if (this.useTrafficLights) {
      const spacer = document.createElement("div");
      spacer.classList.add("spacer", "flex-grow");
      this.containerHeader.appendChild(spacer);

      this.searchControlContainer.classList.add("gone");

      this.containerHeader.appendChild(this.trafficLightContainer);

      this.containerHeader.onclick = async () => {
        if (this.isSubContainer) {
          if (this.containerHeader.classList.contains("open")) {
            this.subTopicClose();
          } else {
            this.subTopicOpen();
          }
        } else {
          if (this.containerHeader.classList.contains("open")) {
            this.topicClose();
          } else {
            this.topicOpen();
          }
        }
      };

      if (this.isSubContainer) {
        this.containerHeader.classList.add("sub-traffic-light-topic");
      } else {
        this.containerHeader.classList.add("traffic-light-topic");
      }

      this.topicMainContainer.appendChild(this.trafficLightContentContainer);
      this.trafficLightContentContainer.appendChild(this.trafficLightContentWrapper);
    } else {
      this.subTopicNavigationContainer.classList.add("gone");
    }

    this.container.appendChild(this.header);
    this.container.appendChild(this.searchIcon);
    this.container.appendChild(this.searchControlContainer);
    this.container.appendChild(this.subTopicNavigationContainer);

    this.searchControlContainer.appendChild(this.searchPreviousButton);
    this.searchControlContainer.appendChild(this.searchNextButton);
    this.searchControlContainer.appendChild(this.searchCancelButton);

    this.subTopicNavigationContainer.appendChild(this.subTopicNavigationPreviousButton);
    this.subTopicNavigationContainer.appendChild(this.subTopicNavigationNextButton);

    // this.trafficLightContainer.appendChild(this.statusLight);
    this.container.prepend(this.statusLight);

    this.trafficLightContainer.appendChild(this.toggleTrafficButton);
    this.toggleTrafficButton.appendChild(this.trafficButtonTriangle);

    this.searchIcon.innerHTML =
      '<svg focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg>';
    this.searchIcon.title = translate("search");

    this.searchPreviousButton.innerHTML = '<i class="fa fa-chevron-left"></i>';
    this.searchNextButton.innerHTML = '<i class="fa fa-chevron-right"></i>';
    this.searchCancelButton.innerHTML = '<i class="fa fa-times"></i>';

    this.subTopicNavigationPreviousButton.innerHTML = '<i class="fa fa-chevron-left"></i>';
    this.subTopicNavigationNextButton.innerHTML = '<i class="fa fa-chevron-right"></i>';

    this.topic = topic;
    this.setTopicHeader(topic);
    this.header.appendChild(this.topicStrong);

    this.searchIcon.onclick = async (event) => {
      event.stopPropagation();
      if (!this.container.classList.contains("active")) {
        await setActiveSearchTopic(this);
        this.container.classList.add("active");
      }
    };

    this.searchPreviousButton.onclick = async (event) => {
      event.stopPropagation();
      if (this.currentSearchIndex === 0) return;
      this.currentSearchIndex--;
      // await searchTextRanges(this.topic, true, this.currentSearchIndex);
      await searchTextinDocument(this.topic, true, this.currentSearchIndex);
      this.checkSearchButtons();
    };
    this.searchNextButton.onclick = async (event) => {
      event.stopPropagation();
      if (this.currentSearchIndex === this.searchResCount - 1) return;
      this.currentSearchIndex++;
      // await searchTextRanges(this.topic, true, this.currentSearchIndex);
      await searchTextinDocument(this.topic, true, this.currentSearchIndex);
      this.checkSearchButtons();
    };
    this.searchCancelButton.onclick = async (event) => {
      event.stopPropagation();
      await this.deactivate();
    };

    this.subTopicNavigationContainer.onclick = (event) => {
      event.stopPropagation();
    };
    this.subTopicNavigationPreviousButton.onclick = async (event) => {
      event.stopPropagation();
      this.handleSubTopicNavigation(false);
    };
    this.subTopicNavigationNextButton.onclick = async (event) => {
      event.stopPropagation();
      this.handleSubTopicNavigation(true);
    };

    this.setupSubTopicNavigation();

    if (statusUpdateCallback != null) {
      this.statusUpadteCallback = statusUpdateCallback;
    }

    // TESTING: - OLD SETUP
    // this.createTrafficLightEntry = this.createTrafficLightEntryOLD.bind(this);
    // this.addToTrafficLightEntry = this.addToTrafficLightEntryOLD.bind(this);
  }

  public root(): HTMLDivElement {
    return this.topicMainContainer;
  }

  public setTopicHeader(topic: string) {
    this.topic = topic;
    this.topicStrong.textContent = topic;
  }

  public setupSubTopicNavigation() {
    this.subTopicNavigationPreviousButton.disabled = true;
    this.subTopicNavigationNextButton.disabled = this.clauseSubTopicEntries.length < 1;
    this.currentSubTopicIndex = -1;
  }

  private handleSubTopicNavigation(next: boolean) {
    if (this.isSubContainer) return;
    if (this.clauseSubTopicEntries.length === 0) return;

    this.currentSubTopicIndex += next ? 1 : -1;

    if (this.currentSubTopicIndex <= 0) {
      this.currentSubTopicIndex = 0;
      this.subTopicNavigationPreviousButton.disabled = true;
    } else {
      this.subTopicNavigationPreviousButton.disabled = false;
    }

    if (this.currentSubTopicIndex >= this.clauseSubTopicEntries.length - 1) {
      this.currentSubTopicIndex = this.clauseSubTopicEntries.length - 1;
      this.subTopicNavigationNextButton.disabled = true;
    } else {
      this.subTopicNavigationNextButton.disabled = false;
    }

    this.clauseSubTopicEntries.forEach((subEntry, index) => {
      if (index === this.currentSubTopicIndex) {
        subEntry.subTopicOpen();
      } else {
        subEntry.subTopicClose();
      }
    });
  }

  public async deactivate() {
    this.container.classList.remove("active");
    // await searchTextRanges(this.topic, true, this.currentSearchIndex, true);
    this.searchResCount = 0;
    this.currentSearchIndex = 0;
    this.searchPreviousButton.disabled = false;
    this.searchNextButton.disabled = false;
  }

  public topicOpen() {
    this.topicMainContainer.classList.add("topic-container-open");
    this.container.classList.add("active");
    this.toggleTrafficButton.classList.add("open");
    this.trafficLightContentContainer.classList.remove("collapse");
    this.containerHeader.classList.add("open");
  }

  public async subTopicOpen() {
    console.log("subTopicOpen", this.topicMainContainer);
    // console.log("trafficLightSubTopicOpenOk", trafficLightSubTopicOpenOk);

    //  if (!trafficLightSubTopicOpenOk) return;

    runOfficeTask(async () => {
      this.topicMainContainer.classList.add("sub-topic-container-open");
      this.toggleTrafficButton.classList.add("open");
      this.trafficLightContentContainer.classList.remove("collapse");
      this.containerHeader.classList.add("open");

      if (
        globalMainContainer &&
        !isElementVisibleInContainer(this.topicMainContainer, globalMainContainer)
      ) {
        this.topicMainContainer.scrollIntoView({ behavior: "smooth" });
      }

      await searchAndSelectText(this.currentSubTopicRelevantText);
    });
  }

  public topicClose() {
    // TODO: check if needed
    this.searchCancelButton.click();

    // TODO: close all sub-topic containers?
    // this.setupSubTopicNavigation();

    this.toggleTrafficButton.classList.remove("open");
    this.trafficLightContentContainer.classList.add("collapse");
    this.containerHeader.classList.remove("open");
    this.topicMainContainer.classList.remove("topic-container-open");

    this.setupSubTopicNavigation();
  }

  public subTopicClose() {
    // TODO: check if needed
    this.searchCancelButton.click();

    this.toggleTrafficButton.classList.remove("open");
    this.trafficLightContentContainer.classList.add("collapse");
    this.containerHeader.classList.remove("open");
    this.topicMainContainer.classList.remove("sub-topic-container-open");
  }

  public setSearchRanges(searchResCount: number) {
    this.searchResCount = searchResCount;
    this.checkSearchButtons();
  }

  private checkSearchButtons() {
    if (this.searchResCount <= 1) {
      this.searchPreviousButton.disabled = true;
      this.searchNextButton.disabled = true;
      return;
    }
    if (this.currentSearchIndex === 0) {
      this.searchPreviousButton.disabled = true;
      this.searchNextButton.disabled = false;
    } else if (this.currentSearchIndex === this.searchResCount - 1) {
      this.searchNextButton.disabled = true;
      this.searchPreviousButton.disabled = false;
    } else {
      this.searchPreviousButton.disabled = false;
      this.searchNextButton.disabled = false;
    }
  }

  public async createTrafficLightEntry(
    llmMessage: IOMainLLMMessage,
    topicSteps: Record<string, number>
  ) {
    this.messageCounter++;

    this.currentTrafficLightEntryTextRaw = "";
    this.currentTrafficLightEntry = document.createElement("div");
    this.currentTrafficLightEntry.classList.add("traffic-light-entry", "flex", "flex-col");

    this.searchIcon.classList.add("gone");

    if (this.messageCounter === 1) {
      return;
    }
    this.trafficLightContentWrapper.appendChild(this.currentTrafficLightEntry);

    this.trafficLightSummary?.getDeviationCard("deviation", false)?.clearAddCount();
    this.trafficLightSummary?.getDeviationCard("missing", false)?.clearAddCount();
    //console.log("addToTrafficLightEntry in createTrafficLightEntry", llmMessage);

    this.addToTrafficLightEntry(llmMessage);
  }

  // private setTrafficLightStatus(): boolean {
  //   let isGreen = false;
  //   try {
  //     const statusValue = this.lastjsonFirstValue.toLowerCase();
  //     switch (statusValue) {
  //       case "true":
  //         this.statusLight.classList.add("failure");
  //         break;
  //       case "false":
  //         this.statusLight.classList.add("success");
  //         isGreen = true;
  //         break;
  //       default:
  //         console.warn("Traffic light status not recognized: ", statusValue);
  //         break;
  //     }
  //   } catch (error) {
  //     console.error("Error setting traffic light status: ", error);
  //   } finally {
  //     return isGreen;
  //   }
  // }

  private setTrafficLightColor(color: ColorStyle): void {
    this.statusLight.classList.remove(...colorStyleArray);
    switch (color) {
      case "green":
        this.statusLight.classList.add("green", "bs");
        this.statusIsGreen = true;
        break;
      case "yellow":
        this.statusLight.classList.add("yellow", "bs");
        break;
      case "red":
        this.statusLight.classList.add("red", "bs");
        break;
      default:
        console.warn("Unknown traffic light color: ", color);
        break;
    }
  }

  public async completeTrafficLightEntry(llmMessage: IOMainLLMMessage) {
    console.log("completeTrafficLightEntry called", {
      currentEntry: this.currentTrafficLightEntry,
      rawText: this.currentTrafficLightEntryTextRaw,
    });

    if (this.currentTrafficLightEntry === null) {
      console.warn("No current traffic light entry to add to.");
      return;
    }

    this.currentTrafficLightEntryTextRaw += llmMessage.content;

    // Clear the arrays to start fresh
    this.clauseSubTopicEntries = [];
    this.deviationSubTopicEntries = [];
    this.missingSubTopicEntries = [];

    const trafficLightResultObject: TrafficLightResultObject | null =
      createTrafficLightResultObject(this.currentTrafficLightEntryTextRaw);

    console.log("trafficLightResultObject", trafficLightResultObject);

    if (trafficLightResultObject === null) {
      const messageContainer = new LLMMessageContainer(
        {
          ...llmMessage,
          content: this.currentTrafficLightEntryTextRaw,
        },
        true,
        this.taskCategory
      );
      this.currentTrafficLightEntry.appendChild(messageContainer.root());

      // ✅ ADD: Ensure it's in the DOM
      if (!this.currentTrafficLightEntry.parentElement) {
        this.trafficLightContentWrapper.appendChild(this.currentTrafficLightEntry);
      }

      console.log("the created object is null, returning");
      return;
    }

    // Set the status color
    if (trafficLightResultObject.Overall_deviation !== null && !this.initialStatusColorSet) {
      this.setTrafficLightColor(trafficLightResultObject.Overall_deviation ? "red" : "green");
      this.initialStatusColorSet = true;
    }

    // ✅ ADD: Ensure the entry is in the DOM BEFORE adding children
    if (!this.currentTrafficLightEntry.parentElement) {
      this.trafficLightContentWrapper.appendChild(this.currentTrafficLightEntry);
    }

    // Handle missing clauses
    if (
      trafficLightResultObject.Missing_required_clause &&
      trafficLightResultObject.Suggested_insertion
    ) {
      const translatedAction = translate("add");
      const clauseHeaderText = `${translate("snippet")} ${this.clauseSubTopicEntries.length + 1} | ${translatedAction}`;

      const missingClauseTopicContainerSubEntry = new LLMMessageTopicContainer(
        clauseHeaderText,
        this.setActiveSearchTopicFunction,
        this.taskCategory,
        this.useTrafficLights,
        true, // isSubContainer
        this.statusUpadteCallback.bind(this),
        this.trafficLightSummary,
        this
      );

      this.currentTrafficLightEntry.appendChild(missingClauseTopicContainerSubEntry.root());

      const missingClause: ClauseReview = {
        Action: "Add",
        clause_text: trafficLightResultObject.Suggested_insertion,
        Reason: "",
        Suggested_replacement: "",
      } as ClauseReview;

      missingClauseTopicContainerSubEntry.addClause(
        missingClause,
        missingClauseTopicContainerSubEntry
      );

      this.clauseSubTopicEntries.push(missingClauseTopicContainerSubEntry);
      this.missingSubTopicEntries.push(missingClauseTopicContainerSubEntry);

      this.setupSubTopicNavigation();
    }

    // Handle clause reviews
    if (trafficLightResultObject.Clauses_review.length > 0) {
      for (const clause of trafficLightResultObject.Clauses_review) {
        const translatedAction = clause.Action ? translate(clause.Action.toLocaleLowerCase()) : "";
        const clauseHeaderText = `${translate("snippet")} ${this.clauseSubTopicEntries.length + 1} | ${translatedAction}`;

        const clauseTopicContainerSubEntry = new LLMMessageTopicContainer(
          clauseHeaderText,
          this.setActiveSearchTopicFunction,
          this.taskCategory,
          this.useTrafficLights,
          true, // isSubContainer
          this.statusUpadteCallback.bind(this),
          this.trafficLightSummary,
          this
        );

        this.currentTrafficLightEntry.appendChild(clauseTopicContainerSubEntry.root());
        clauseTopicContainerSubEntry.addClause(clause, clauseTopicContainerSubEntry);

        this.clauseSubTopicEntries.push(clauseTopicContainerSubEntry);

        if (clause.Action === "Replace" || clause.Action === "Delete") {
          this.deviationSubTopicEntries.push(clauseTopicContainerSubEntry);
        }

        this.setupSubTopicNavigation();
      }
    }

    // Update deviation cards
    this.trafficLightSummary
      ?.getDeviationCard("deviation", true)
      ?.addCount(this.deviationSubTopicEntries);
    this.trafficLightSummary
      ?.getDeviationCard("missing", true)
      ?.addCount(this.missingSubTopicEntries);
  }

  public async addToTrafficLightEntry(llmMessage: IOMainLLMMessage) {
    if (this.currentTrafficLightEntry === null) {
      console.warn("No current traffic light entry to add to.");
      return;
    }

    this.currentTrafficLightEntryTextRaw += llmMessage.content;
    return;
    //console.log("raw text after addToTrafficLightEntry", llmMessage.content);

    console.log("Clearing innerHTML - THIS REMOVES ALL SUB-TOPICS!");
    this.currentTrafficLightEntry.innerHTML = "";
    this.clauseSubTopicEntries = [];
    this.deviationSubTopicEntries = [];
    this.missingSubTopicEntries = [];

    const trafficLightResultObject: TrafficLightResultObject | null =
      createTrafficLightResultObject(this.currentTrafficLightEntryTextRaw);

    console.log(
      "cleared all HTML and created new trafficLightResultObject",
      trafficLightResultObject
    );

    // console.log("trafficLightResultObject", trafficLightResultObject);

    if (trafficLightResultObject === null) {
      const messageContainer = new LLMMessageContainer(
        {
          ...llmMessage,
          content: this.currentTrafficLightEntryTextRaw,
        },
        true,
        this.taskCategory
      );
      this.currentTrafficLightEntry.appendChild(messageContainer.root());
      console.log("the created object is null, returniung");
      return;
    }
    console.log("created result is not null, ", trafficLightResultObject);
    // topic collapse status indicator light
    if (trafficLightResultObject.Overall_deviation !== null && !this.initialStatusColorSet) {
      this.setTrafficLightColor(trafficLightResultObject.Overall_deviation ? "red" : "green");
      this.initialStatusColorSet = true;
    }

    if (
      trafficLightResultObject.Missing_required_clause &&
      trafficLightResultObject.Suggested_insertion
    ) {
      const translatedAction = translate("add");
      const clauseHeaderText = `${translate("snippet")} ${this.clauseSubTopicEntries.length + 1} | ${translatedAction}`;

      const missingClauseTopicContainerSubEntry = new LLMMessageTopicContainer(
        clauseHeaderText,
        this.setActiveSearchTopicFunction,
        this.taskCategory,
        this.useTrafficLights,
        true, // isSubContainer
        this.statusUpadteCallback.bind(this),
        this.trafficLightSummary,
        this
      );

      console.log(
        "created missingClauseTopicContainerSubEntry",
        missingClauseTopicContainerSubEntry
      );

      this.currentTrafficLightEntry.appendChild(missingClauseTopicContainerSubEntry.root());

      const missingClause: ClauseReview = {
        Action: "Add", // add missing
        clause_text: trafficLightResultObject.Suggested_insertion,
        Reason: "",
        Suggested_replacement: "",
      } as ClauseReview;

      // topic header search icon removed in addClause
      missingClauseTopicContainerSubEntry.addClause(
        missingClause,
        missingClauseTopicContainerSubEntry
      );

      this.clauseSubTopicEntries.push(missingClauseTopicContainerSubEntry);
      this.missingSubTopicEntries.push(missingClauseTopicContainerSubEntry);

      this.setupSubTopicNavigation();
    }

    if (trafficLightResultObject.Clauses_review.length > 0) {
      for (const clause of trafficLightResultObject.Clauses_review) {
        // TESTING: - no delete in answer
        // if (clause.Action === "Keep") clause.Action = "Delete";

        const translatedAction = clause.Action ? translate(clause.Action.toLocaleLowerCase()) : "";
        const clauseHeaderText = `${translate("snippet")} ${this.clauseSubTopicEntries.length + 1} | ${translatedAction}`;

        const clauseTopicContainerSubEntry = new LLMMessageTopicContainer(
          clauseHeaderText,
          this.setActiveSearchTopicFunction,
          this.taskCategory,
          this.useTrafficLights,
          true, // isSubContainer
          this.statusUpadteCallback.bind(this),
          this.trafficLightSummary,
          this
        );
        console.log("created clauseTopicContainerSubEntry", clauseTopicContainerSubEntry);
        this.currentTrafficLightEntry.appendChild(clauseTopicContainerSubEntry.root());
        // topic header search icon removed in addClause
        clauseTopicContainerSubEntry.addClause(clause, clauseTopicContainerSubEntry);

        this.clauseSubTopicEntries.push(clauseTopicContainerSubEntry);

        if (clause.Action === "Replace" || clause.Action === "Delete") {
          this.deviationSubTopicEntries.push(clauseTopicContainerSubEntry);
        }

        this.setupSubTopicNavigation();
      }
    }

    this.trafficLightSummary
      ?.getDeviationCard("deviation", true)
      ?.addCount(this.deviationSubTopicEntries);
    this.trafficLightSummary
      ?.getDeviationCard("missing", true)
      ?.addCount(this.missingSubTopicEntries);

    console.log("Created sub-topics:", this.clauseSubTopicEntries.length);
  }

  private statusUpadteCallback(
    isDelete: boolean = false,
    isReplace: boolean = false,
    addedMissing: boolean = false,
    thisSubTopicContainer: LLMMessageTopicContainer = this
  ) {
    if (isDelete || isReplace) {
      this.trafficLightSummary?.getDeviationCard("deviation")?.decreaseCount(thisSubTopicContainer);
    }
    if (addedMissing) {
      this.trafficLightSummary?.getDeviationCard("missing")?.decreaseCount(thisSubTopicContainer);
    }

    for (const subEntry of this.clauseSubTopicEntries) {
      if (!subEntry.statusIsGreen) {
        this.currentTrafficLightEntry!.style.borderLeft = `2px solid ${colorStyleToRGB("red")}`;
        this.currentTrafficLightEntry!.style.margin = "0px 4px";
        return;
      }
    }
    this.setTrafficLightColor("green");
    this.currentTrafficLightEntry!.style.borderLeft = `2px solid ${colorStyleToRGB("green")}`;
    this.currentTrafficLightEntry!.style.margin = "0px 4px";
  }

  private deleteCallback(deleteResult: boolean) {
    if (deleteResult) {
      this.setTrafficLightColor("green");
      this.statusUpadteCallback(true, false, false, this);
    }
  }

  private replaceCallback(replaceResult: boolean) {
    if (replaceResult) {
      this.setTrafficLightColor("green");
      this.statusUpadteCallback(false, true, false, this);
    }
  }

  private addMissingCallback(missingResult: boolean) {
    if (missingResult) {
      this.setTrafficLightColor("green");
      this.statusUpadteCallback(false, false, true, this);
    }
  }

  public async addClause(claus: ClauseReview, subTopicContainer: LLMMessageTopicContainer) {
    this.searchIcon.classList.add("gone");

    let clauseColor: ColorStyle;
    let isKeep: boolean = false;
    let isDelete: boolean = false;
    let isReplace: boolean = false;
    let isAdd: boolean = false;

    if (!claus.Action) {
      return; // no action defined, nothing to do
    }

    const actionLower = claus.Action.toLowerCase();
    switch (actionLower) {
      case "keep":
        clauseColor = "green";
        isKeep = true;
        break;
      case "delete":
        clauseColor = "red";
        isDelete = true;
        break;
      case "replace":
        clauseColor = "red"; // "yellow"
        isReplace = true;
        break;
      case "add":
        clauseColor = "red";
        isAdd = true;
        break;
      default:
        console.warn("Unknown clause action: ", claus.Action);
        clauseColor = "red"; // fallback
        break;
    }

    this.currentSubTopicRelevantText = claus.clause_text || "";

    this.setTrafficLightColor(clauseColor);
    // this.trafficLightContentContainer.style.borderLeft = `2px solid ${colorStyleToRGB(clauseColor)}`;

    if (claus.Reason) {
      this.addFixedEntry(subTopicContainer, claus.Reason, translate("reason"), true);
    }

    if (claus.clause_text) {
      this.addFixedEntry(
        subTopicContainer,
        claus.clause_text,
        isAdd ? translate("missing-required-clause") : translate("current-text"),
        !(isDelete || isAdd),
        isDelete,
        isReplace,
        isAdd,
        "",
        claus.clause_text
      );

      this.currentTrafficLightEntry!.classList.add("hover-pointer");
      this.currentTrafficLightEntry!.title = translate("search-in-document");
      this.currentTrafficLightEntry!.onclick = () => searchAndSelectText(claus.clause_text);

      if (isKeep) {
        this.currentTrafficLightEntry!.classList.add("bg-light-green");
        this.currentTrafficLightEntry!.style.padding = "10px";
        this.currentTrafficLightEntry!.style.borderLeft = `2px solid ${colorStyleToRGB("green")}`;
        this.currentTrafficLightEntry!.style.color = colorStyleToRGB("green");
      } else {
        this.currentTrafficLightEntry!.classList.add("bg-light-red");
        this.currentTrafficLightEntry!.style.padding = "10px";
        this.currentTrafficLightEntry!.style.borderLeft = `2px solid ${colorStyleToRGB("red")}`;
      }
    }

    if (claus.Suggested_replacement) {
      this.addFixedEntry(
        subTopicContainer,
        claus.Suggested_replacement,
        translate("suggested-change"),
        false,
        isDelete,
        isReplace,
        isAdd,
        claus.clause_text
      );

      this.currentTrafficLightEntry!.classList.add("bg-light-green");
      this.currentTrafficLightEntry!.style.padding = "10px";
      this.currentTrafficLightEntry!.style.borderLeft = `2px solid ${colorStyleToRGB("green")}`;
      this.currentTrafficLightEntry!.style.color = colorStyleToRGB("green");
    }
  }

  private addFixedEntry(
    subTopicContainer: LLMMessageTopicContainer,
    content: string,
    header?: string,
    hideControls?: boolean,
    isDelete: boolean = false,
    isReplace: boolean = false,
    isAdd: boolean = false,
    replaceOriginText: string = "",
    deleteText: string = ""
  ) {
    this.currentTrafficLightEntryTextRaw = content;
    this.currentTrafficLightEntry = document.createElement("div");
    this.currentTrafficLightEntry.classList.add("traffic-light-entry", "flex", "flex-col");
    this.trafficLightContentWrapper.appendChild(this.currentTrafficLightEntry);

    if (header) {
      // this.currentTrafficLightEntry.appendChild(this.getStrongDiv(header + ":"));
      const headerText = document.createElement("p");
      headerText.textContent = header.toUpperCase() + ":";
      this.currentTrafficLightEntry.appendChild(headerText);
    }

    const contentMessage: IOMainLLMMessage = {
      // server: "n/a",
      category: "chat",
      type: "heartbeat",
      content,
      role: "assistant",
      model: "n/a",
      timestamp: 0,
    };
    const messageContainer: LLMMessageContainer = new LLMMessageContainer(
      contentMessage,
      hideControls,
      this.taskCategory,
      false,
      isDelete,
      isReplace,
      true // isInTrafficLight
    );
    this.currentTrafficLightEntry.appendChild(messageContainer.root());

    if (isDelete) {
      messageContainer.setButtonDeleteFunction(
        searchAndDeleteText,
        subTopicContainer.deleteCallback.bind(subTopicContainer),
        deleteText
      );
    }

    if (isReplace) {
      messageContainer.setButtonSearchAndReplaceFunction(
        searchAndReplaceText,
        subTopicContainer.replaceCallback.bind(subTopicContainer),
        replaceOriginText,
        content
      );
    }

    if (isAdd) {
      messageContainer.setButtonAddMissingFunction(
        insertAtCurrentPosition,
        subTopicContainer.addMissingCallback.bind(subTopicContainer),
        content
      );
    }
  }

  // public async addToTrafficLightEntryOLD(llmMessage: IOMainLLMMessage) {
  //   if (this.currentTrafficLightEntry) {
  //     this.currentTrafficLightEntryTextRaw += llmMessage.content;
  //     this.currentTrafficLightEntry.innerHTML = "";

  //     try {
  //       const parsedJson = parseJson(this.currentTrafficLightEntryTextRaw);
  //       const firstKey = Object.keys(parsedJson).at(0);
  //       if (firstKey) {
  //         let firstValue = parsedJson[firstKey];
  //         this.lastjsonFirstValue = firstValue.toString().trim();

  //         const keyDiv = document.createElement("div");
  //         const keyStrong = document.createElement("strong");
  //         keyStrong.textContent = firstKey.split("_").join(" ") + ":";
  //         keyStrong.classList.add("tl-m1");
  //         keyDiv.appendChild(keyStrong);
  //         this.currentTrafficLightEntry.appendChild(keyDiv);

  //         if (this.messageCounter === 3) {
  //           keyStrong.classList.add("bg-light-red");
  //         }
  //         if (this.messageCounter === 4) {
  //           keyStrong.classList.add("bg-light-green");
  //         }

  //         // const valueDiv = document.createElement("div");
  //         // valueDiv.textContent = firstValue;
  //         // this.currentTrafficLightEntry.appendChild(valueDiv);

  //         if (firstValue.toString().trim() === "") {
  //           firstValue = "N/A";
  //         }
  //         const messageContainer = new LLMMessageContainer(
  //           {
  //             ...llmMessage,
  //             content: firstValue,
  //           },
  //           this.messageCounter !== 4,
  //           this.taskCategory
  //         );
  //         this.currentTrafficLightEntry.appendChild(messageContainer.root());
  //       } else {
  //         throw new ce.ParseJsonError("Error parsing JSON");
  //       }
  //     } catch (error) {
  //       // if (this.messageCounter === 1) {
  //       //   const keyDiv = document.createElement("div");
  //       //   const keyStrong = document.createElement("strong");
  //       //   keyStrong.textContent = "Im Vertrag gefunden:";
  //       //   keyStrong.classList.add("tl-m1");
  //       //   keyDiv.appendChild(keyStrong);
  //       //   this.currentTrafficLightEntry.appendChild(keyDiv);
  //       // }
  //       const messageContainer = new LLMMessageContainer(
  //         {
  //           ...llmMessage,
  //           content: this.currentTrafficLightEntryTextRaw,
  //         },
  //         true,
  //         this.taskCategory
  //       );
  //       this.currentTrafficLightEntry.appendChild(messageContainer.root());
  //     }
  //   }
  // }
}

class BasicMessageContainer {
  private container: HTMLDivElement; // container for the llm message
  private contentContainer: HTMLDivElement; // container for the llm message content
  private textContainer: HTMLDivElement; // the text of the llm message
  private textElement: HTMLElement; // the formatted text of the llm message
  public metadataControl: LLMMetadataControl; // the control for the metadata of the llm message
  public rawText: string = ""; // the raw text of the llm message
  public htmlText: string = ""; // the html rendered text of the llm message
  public displayedText: string = ""; // the displayed text of the llm message
  private role: LLMStreamEventRolePlus; // the role of the llm message (user or assistant)

  constructor(basicMessage: IOBasicMessage) {
    this.container = document.createElement("div");
    this.contentContainer = document.createElement("div");
    this.textContainer = document.createElement("div");
    this.textElement = document.createElement("div");
    this.metadataControl = new LLMMetadataControl(basicMessage);

    this.container.appendChild(this.contentContainer);

    this.contentContainer.appendChild(this.textContainer);
    this.contentContainer.appendChild(this.metadataControl.root());

    this.textContainer.appendChild(this.textElement);

    this.container.classList.add("llm-message-container");

    this.contentContainer.classList.add("llm-message-content-container");
    this.role = basicMessage.role;
    if (this.role === "option") {
      this.contentContainer.classList.add("option-message");
    }

    this.addText(basicMessage.text);

    // ########################################################################
    // metadata control button actions ########################################
    // ########################################################################
    this.metadataControl.buttonCopyText.onclick = () => {
      navigator.clipboard.writeText(this.displayedText);
    };
    this.metadataControl.buttonInsertAtCursor.onclick = () => {
      // insertAtCurrentPosition(this.rawText);
      insertHtmlAtSelection(this.htmlText, "Replace");
    };

    // this.metadataControl.buttonReplaceSelection.onclick = async () =>
    //   await insertHtmlAtSelection(this.htmlText, "Replace");
    // this.metadataControl.buttonInsertBeforeSelection.onclick = async () =>
    //   await insertHtmlAtSelection(this.htmlText, "Before");
    // this.metadataControl.buttonInsertAfterSelection.onclick = async () =>
    //   await insertHtmlAtSelection(this.htmlText, "After");
    // ########################################################################
    // ########################################################################
    // ########################################################################
  }

  public root(): HTMLDivElement {
    return this.container;
  }

  public async addText(text: string) {
    this.rawText += text.trim();
    if (this.rawText.startsWith('"') && this.rawText.endsWith('"')) {
      this.rawText = this.rawText.slice(1, -1).trim();
    }
    const htmlTextContent = await marked(this.rawText);
    const sanitizedHtmlTextContent = DOMPurify.sanitize(htmlTextContent);
    this.htmlText = sanitizedHtmlTextContent;
    this.textElement.innerHTML = sanitizedHtmlTextContent;
    this.displayedText = this.textElement.textContent ?? this.rawText;
  }

  public getRole(): LLMStreamEventRolePlus {
    return this.role;
  }
}

class LLMMessageContainer {
  private container: HTMLDivElement; // container for the llm message
  private contentContainer: HTMLDivElement; // container for the llm message content
  private header: HTMLHeadingElement; // the user or assistant event type (e.g. "Q: ", "A: ")
  private textContainer: HTMLDivElement; // the text of the llm message
  private textElement: HTMLElement; // the formatted text of the llm message
  public metadataControl: LLMMetadataControl; // the control for the metadata of the llm message
  public rawText: string = ""; // the raw text of the llm message
  public htmlText: string = ""; // the html rendered text of the llm message
  public displayedText: string = ""; // the displayed text of the llm message
  private role: LLMStreamEventRole; // the role of the llm message (user or assistant)
  private type: LLMStreamEventType; // the type of the llm message (e.g. "user_chat", "assistant_chat", ...)
  public topic: string; // the topic of the llm message
  public isTypeFiltered: boolean = true; // flag to indicate if the message type is filtered
  public isTopicFiltered: boolean = true; // flag to indicate if the message topic is filtered
  private taskCategory: TaskCategory;
  private currentMessageCompletionDebounce: NodeJS.Timeout | null = null;
  private hideControls: boolean = false;
  private isInTrafficLight: boolean = false;

  // traffic light related flags
  private deleteUsed: boolean = false;
  private replaceUsed: boolean = false;
  private insertUsed: boolean = false;

  constructor(
    llmMessage: IOMainLLMMessage,
    hideControls: boolean = false,
    taskCategory: TaskCategory,
    hideContainer: boolean = false,
    controlShowOnlyDeleteButton: boolean = false,
    controlShowSearchAndReplaceButton: boolean = false,
    isInTrafficLight: boolean = false
  ) {
    this.taskCategory = taskCategory;
    this.hideControls = hideControls;
    this.isInTrafficLight = isInTrafficLight;

    this.container = document.createElement("div");
    this.contentContainer = document.createElement("div");
    this.header = document.createElement("h3");
    this.textContainer = document.createElement("div");
    this.textElement = document.createElement("div");
    this.metadataControl = new LLMMetadataControl(
      llmMessage,
      taskCategory,
      controlShowOnlyDeleteButton,
      controlShowSearchAndReplaceButton,
      isInTrafficLight
    );

    this.container.appendChild(this.contentContainer);

    if (this.hideControls) {
      this.metadataControl.root().classList.add("gone");
    }
    if (hideContainer) {
      this.container.classList.add("gone");
    }

    // this.contentContainer.appendChild(this.header);
    this.contentContainer.appendChild(this.textContainer);
    if (llmMessage.role === "assistant") {
      this.contentContainer.appendChild(this.metadataControl.root());
    }

    this.container.classList.add("llm-message-container");

    // set topic of the message (if available)
    this.topic = llmMessage.topic ?? "";

    const headerText = `${LLMStreamEventLabel[llmMessage.type]}`;
    this.header.textContent = headerText;
    this.role = llmMessage.role;
    this.type = llmMessage.type;

    this.contentContainer.classList.add("llm-message-content-container");
    if (this.role === "user") {
      this.contentContainer.classList.add("user-message");
    }
    this.header.classList.add("llm-message-header");

    this.textContainer.appendChild(this.textElement);

    if (!(this.taskCategory === "edit-document" && llmMessage.role === "user")) {
      this.addText(llmMessage.content);
    }

    // ########################################################################
    // metadata control button actions ########################################
    // ########################################################################
    this.metadataControl.buttonCopyText.onclick = () => {
      navigator.clipboard.writeText(this.displayedText);
    };
    this.metadataControl.buttonInsertAtCursor.onclick = () => {
      // insertAtCurrentPosition(this.rawText);

      // console.log("selected text: ", getSelectedTextHtml());
      // return;

      insertHtmlAtSelection(this.htmlText, "Replace");
    };

    // this.metadataControl.buttonShowInfo.onclick = () => {
    //   if (this.metadataContainer.root().clientHeight === 0) {
    //     this.metadataContainer.root().style.display = "block";
    //     this.metadataContainer.root().style.maxHeight = this.metadataContainer.root().scrollHeight + "px";
    //   } else {
    //     this.metadataContainer.root().style.maxHeight = "0";
    //     setTimeout(() => {
    //       this.metadataContainer.root().style.display = "none";
    //     }, 333);
    //   }
    //   this.metadataControl.buttonShowInfo.classList.toggle("open");
    // };

    this.metadataControl.buttonInsertText.onclick = () => {
      insertCommentIntoWord(this.rawText);
    };
    if (!Office.context.requirements.isSetSupported("WordApi", "1.4")) {
      this.metadataControl.buttonInsertText.disabled = true;
      this.metadataControl.buttonInsertText.style.cursor = "default"; // not-allowed
      this.metadataControl.buttonInsertText.title = translate("comments-not-supported");
    }

    this.metadataControl.buttonReplaceDocumentContent.onclick = async () => {
      try {
        // replaceDocumentContent(this.rawText);
        // setHtmlContent(this.htmlText);
        await replaceHtmlBodyContent(this.htmlText);
      } catch (error) {
        console.log("Error: ", error);
      }
    };

    // this.metadataControl.buttonReplaceSelection.onclick = async () =>
    //   await insertHtmlAtSelection(this.htmlText, "Replace");
    // this.metadataControl.buttonInsertBeforeSelection.onclick = async () =>
    //   await insertHtmlAtSelection(this.htmlText, "Before");
    // this.metadataControl.buttonInsertAfterSelection.onclick = async () =>
    //   await insertHtmlAtSelection(this.htmlText, "After");
    // ########################################################################
    // ########################################################################
    // ########################################################################
  }

  public root(): HTMLDivElement {
    return this.container;
  }

  public async addText(text: any) {
    runOfficeTask(async () => {
      this.rawText += toAnyString(text);

      if (typeof this.rawText === "object" && this.rawText !== null) {
        this.htmlText = await marked("```json\n" + JSON.stringify(this.rawText, null, 2) + "\n```");
      } else {
        this.htmlText = await parseHtmlText(this.rawText.replace(/\\"/g, '"'));
      }

      let displayHtmlText: string = this.htmlText;
      // replace all image tags with placeholder
      // displayHtmlText = displayHtmlText.replace(
      //   /<img\b[^>]*>/gi,
      //   '<img class="llm-image-placeholder" alt="[Bildvorschau nicht verfügbar]">'
      // );
      displayHtmlText = fixWordImgSrc(displayHtmlText);
      displayHtmlText = await replaceImagesWithBase64(displayHtmlText);
      this.textElement.innerHTML = displayHtmlText;

      this.displayedText = this.textElement.textContent ?? this.rawText;

      // maybe enable at llm message completion
      if (this.currentMessageCompletionDebounce) {
        clearTimeout(this.currentMessageCompletionDebounce);
      }
      this.currentMessageCompletionDebounce = setTimeout(() => {
        this.metadataControl.showAll();
      }, 500);
    });
  }

  public async replaceText(text: string) {
    this.rawText = "";
    this.addText(text);
  }

  public getRole(): LLMStreamEventRole {
    return this.role;
  }

  public getType(): LLMStreamEventType {
    return this.type;
  }

  public showReplaceLastSelectionButton(savedSelection: SavedSelection) {
    this.metadataControl.buttonReplaceSavedSelection.classList.remove("gone");
    this.metadataControl.buttonReplaceSavedSelection.onclick = async () => {
      replaceSavedSelection(savedSelection, this.htmlText);
    };
  }
  public hideReplaceLastSelectionButton() {
    this.metadataControl.buttonReplaceSavedSelection.classList.add("gone");
    this.metadataControl.buttonReplaceSavedSelection.onclick = null;
  }

  public setButtonDeleteFunction(
    deleteFunction: (searchText: string) => Promise<boolean>,
    resultCallback: (deleteResult: boolean) => void,
    searchText: string
  ) {
    this.metadataControl.buttonDelete.onclick = async () => {
      const deleteResult: boolean = await deleteFunction(searchText);
      if (this.deleteUsed) return;
      resultCallback(deleteResult);
      this.deleteUsed = deleteResult;
    };
  }

  public setButtonSearchAndReplaceFunction(
    searchAndReplaceFunction: (searchText: string, replaceText: string) => Promise<boolean>,
    resultCallback: (replaceResult: boolean) => void,
    searchText: string,
    replaceText: string
  ) {
    this.metadataControl.buttonSearchAndReplace.onclick = async () => {
      const replaceResult: boolean = await searchAndReplaceFunction(searchText, replaceText);
      if (this.replaceUsed) return;
      resultCallback(replaceResult);
      this.replaceUsed = replaceResult;
    };

    // also search text section for insert-comment
    this.metadataControl.buttonInsertText.onclick = async () => {
      await searchAndSelectText(searchText);
      insertCommentIntoWord(this.rawText);
    };
  }

  public setButtonAddMissingFunction(
    addMissingFunction: (insertText: string) => Promise<boolean>,
    resultCallback: (missingResult: boolean) => void,
    insertText: string
  ) {
    this.metadataControl.buttonInsertAtCursor.classList.add("green");
    this.metadataControl.buttonInsertAtCursor.onclick = async () => {
      const missingResult: boolean = await addMissingFunction(insertText);
      if (this.insertUsed) return;
      resultCallback(missingResult);
      this.insertUsed = missingResult;
    };
  }
}

class LLMMetadataControl {
  private container: HTMLDivElement; // container for the llm metadata control
  private subContainerLeft: HTMLDivElement; // container for the left control buttons
  private subContainerRight: HTMLDivElement; // container for the right control buttons
  private controlButtonListAll: HTMLButtonElement[] = []; // list of all control buttons
  private controlButtonListOption: HTMLButtonElement[] = []; // list of control buttons for options
  private controlButtonListPrompt: HTMLButtonElement[] = []; // list of control buttons for prompts
  private controlButtonListAssistant: HTMLButtonElement[] = []; // list of control buttons for assistants
  public buttonShowInfo: HTMLButtonElement; // button to show the metadata info of the llm message
  public buttonCopyText: HTMLButtonElement; // button to copy the text of the llm message to the clipboard
  public buttonInsertText: HTMLButtonElement; // button to insert the text of the llm message into the editor
  public buttonInsertAtCursor: HTMLButtonElement; // button to insert the text of the llm message at the cursor position
  public buttonReplaceDocumentContent: HTMLButtonElement; // button to replace the document content with the text of the llm message
  public buttonReplaceSelection: HTMLButtonElement; // button to replace the selected text with the text of the llm message
  public buttonInsertBeforeSelection: HTMLButtonElement; // button to insert the text of the llm message before the selected text
  public buttonInsertAfterSelection: HTMLButtonElement; // button to insert the text of the llm message after the selected text
  public buttonReplaceSavedSelection: HTMLButtonElement;
  public buttonDelete: HTMLButtonElement;
  public buttonSearchAndReplace: HTMLButtonElement;

  private taskCategory: TaskCategory | undefined;
  private isInTrafficLight: boolean = false;

  constructor(
    llmMessage: IOMainLLMMessage | IOBasicMessage,
    taskCategory?: TaskCategory,
    showOnlyDelete: boolean = false,
    addSearchAndReplace: boolean = false,
    isInTrafficLight: boolean = false
  ) {
    this.taskCategory = taskCategory;
    this.isInTrafficLight = isInTrafficLight;

    this.container = document.createElement("div");
    this.subContainerLeft = document.createElement("div");
    this.subContainerRight = document.createElement("div");

    this.buttonShowInfo = document.createElement("button");
    this.buttonCopyText = document.createElement("button");
    this.buttonInsertText = document.createElement("button");
    this.buttonInsertAtCursor = document.createElement("button");
    this.buttonReplaceDocumentContent = document.createElement("button");
    this.buttonReplaceSelection = document.createElement("button");
    this.buttonInsertBeforeSelection = document.createElement("button");
    this.buttonInsertAfterSelection = document.createElement("button");
    this.buttonReplaceSavedSelection = document.createElement("button");
    this.buttonDelete = document.createElement("button");
    this.buttonSearchAndReplace = document.createElement("button");

    // this.buttonReplaceSelection
    // this.buttonInsertBeforeSelection
    // this.buttonInsertAfterSelection
    this.controlButtonListOption = [this.buttonInsertAtCursor, this.buttonCopyText];

    // this.buttonShowInfo
    // this.buttonInsertText
    this.controlButtonListPrompt = [this.buttonCopyText];

    // this.buttonReplaceDocumentContent
    // this.buttonReplaceSelection
    // this.buttonInsertBeforeSelection
    // this.buttonInsertAfterSelection
    this.controlButtonListAssistant = [this.buttonInsertAtCursor, this.buttonCopyText];

    this.controlButtonListAll = [
      this.buttonShowInfo,
      this.buttonCopyText,
      this.buttonInsertText,
      this.buttonInsertAtCursor,
      this.buttonReplaceDocumentContent,
      this.buttonReplaceSelection,
      this.buttonInsertBeforeSelection,
      this.buttonInsertAfterSelection,
      this.buttonReplaceSavedSelection,
      this.buttonDelete,
      this.buttonSearchAndReplace,
    ];

    this.subContainerLeft.classList.add("metadata-control-subcontainer", "flex", "flex-row");
    this.container.appendChild(this.subContainerLeft);

    if (this.isInTrafficLight) {
      this.subContainerRight = this.subContainerLeft;

      this.controlButtonListAll.forEach((button) => {
        button.classList.add("metadata-control-button-tl");
      });

      this.container.title = "";
      this.container.classList.add("metadata-control-container-tl", "flex", "flex-row");
      this.container.addEventListener("click", (event) => {
        event.stopPropagation();
      });
      this.container.addEventListener("mouseover", (event) => {
        event.stopPropagation();
      });
    } else {
      this.subContainerRight.classList.add("metadata-control-subcontainer", "flex", "flex-row");
      this.container.appendChild(this.subContainerRight);

      this.controlButtonListAll.forEach((button) => {
        button.classList.add("metadata-control-button");
      });
      this.container.classList.add("metadata-control-container", "flex", "flex-row");
    }

    this.buttonReplaceSavedSelection.classList.add("gone");
    this.buttonDelete.classList.add("gone");
    this.hideAll();

    if (this.taskCategory === "edit-document") {
      this.subContainerLeft.prepend(this.buttonReplaceDocumentContent);
      this.subContainerLeft.prepend(this.buttonReplaceSavedSelection);
    }

    if (this.taskCategory === "workflow") {
      this.subContainerLeft.prepend(this.buttonReplaceDocumentContent);
      this.subContainerLeft.prepend(this.buttonReplaceSavedSelection);
    }

    (llmMessage.role === "option"
      ? this.controlButtonListOption
      : llmMessage.role === "assistant"
        ? this.controlButtonListAssistant
        : this.controlButtonListPrompt
    ).forEach((button) => {
      this.subContainerLeft.appendChild(button);
    });

    if (showOnlyDelete) {
      this.controlButtonListAll.forEach((button) => {
        button.classList.add("gone");
      });
      this.buttonDelete.classList.remove("gone");

      this.buttonDelete.classList.add("green"); // red ?
      this.subContainerLeft.prepend(this.buttonDelete);
    }

    if (addSearchAndReplace) {
      this.buttonSearchAndReplace.classList.add("green");
      this.subContainerLeft.prepend(this.buttonSearchAndReplace);
    }

    if (this.taskCategory === "workflow" || this.taskCategory === "traffic-light") {
      this.subContainerRight.appendChild(this.buttonInsertText);
    }

    // add icons to the buttons
    this.buttonShowInfo.innerHTML = '<i class="fa fa-info"></i>';
    this.buttonCopyText.textContent = translate("copy");
    this.buttonInsertText.textContent = translate("insert-comment");
    this.buttonInsertAtCursor.textContent = translate("paste");
    this.buttonReplaceDocumentContent.textContent = translate("replace-document-content");
    this.buttonReplaceSelection.innerHTML = '<i class="fa fa-exchange"></i>';
    // this.buttonReplaceSelection.innerHTML = `
    // <span style="display: flex; align-items: center; gap: 5px;">
    //   <i class="fa fa-align-left"></i>
    //   <i class="fa fa-exchange"></i>
    // </span>
    // `;
    this.buttonInsertBeforeSelection.innerHTML = '<i class="fa fa-level-up"></i>';
    this.buttonInsertAfterSelection.innerHTML = '<i class="fa fa-level-down"></i>';
    this.buttonReplaceSavedSelection.innerHTML = translate("replace-last-selection");
    this.buttonDelete.innerHTML = translate("search-and-delete");
    this.buttonSearchAndReplace.innerHTML = translate("search-and-replace");

    this.buttonShowInfo.title = translate("show-metadata");
    this.buttonCopyText.title = translate("copy-title");
    this.buttonInsertText.title = translate("insert-comment-title");
    this.buttonInsertAtCursor.title = translate("paste-title");
    this.buttonReplaceDocumentContent.title = translate("replace-document-content");
    this.buttonReplaceSelection.title = translate("replace-selection");
    this.buttonInsertBeforeSelection.title = translate("insert-before-selection");
    this.buttonInsertAfterSelection.title = translate("insert-after-selection");
    this.buttonReplaceSavedSelection.title = translate("replace-last-selection");
    this.buttonDelete.title = translate("search-and-delete-title");
    this.buttonSearchAndReplace.title = translate("search-and-replace-title");

    onContentChange(async () => this.toggleSelectionButtons());
    this.toggleSelectionButtons();
  }

  public root(): HTMLDivElement {
    return this.container;
  }

  public hideAll() {
    this.controlButtonListAll.forEach((button) => {
      button.style.display = "none";
    });
  }

  public showAll() {
    this.controlButtonListAll.forEach((button) => {
      button.style.display = "block";
    });
  }

  private async toggleSelectionButtons() {
    try {
      const selectedText = await getSelectedText();
      if (selectedText === null || selectedText === undefined || selectedText === "") {
        this.buttonReplaceSelection.disabled = true;
        this.buttonInsertBeforeSelection.disabled = true;
        this.buttonInsertAfterSelection.disabled = true;
      } else {
        this.buttonReplaceSelection.disabled = false;
        this.buttonInsertBeforeSelection.disabled = false;
        this.buttonInsertAfterSelection.disabled = false;
      }
    } catch (error) {
      // hmm...
    }
  }
}

let autoScroll = true;
let queuedTarget: HTMLElement | null = null;
let lastScrollTime = 0;
export function scrollToTargetSmooth(target: HTMLElement, force: boolean = false) {
  if (!force) {
    const now = Date.now();
    if (now - lastScrollTime < 100) return;
    lastScrollTime = now;
    if (!autoScroll || queuedTarget === target) return;
    queuedTarget = target;
  }
  requestAnimationFrame(() => {
    target.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
    queuedTarget = null;
  });
}

export function showLoadingIndicator(
  paraenElement: HTMLElement,
  message: string | null = null
): NodeJS.Timeout {
  const loadingDots = document.createElement("div");
  loadingDots.classList.add("loading-dots");
  // loadingDots.textContent = ". ";
  loadingDots.innerHTML = "<strong>. </strong>";

  paraenElement.appendChild(loadingDots);

  let dots = 0;
  const intervalId = setInterval(() => {
    dots = (dots + 1) % 4;
    // loadingDots.textContent = ". ".repeat(dots);
    loadingDots.innerHTML = "<strong>. </strong>".repeat(dots);
  }, 250);

  loadingDots.id = `_${intervalId.toString()}`;

  return intervalId;
}

export function hideLoadingIndicator(
  paraenElement: HTMLElement,
  intervalId: NodeJS.Timeout | null
) {
  if (!paraenElement || !intervalId) return;
  const loadingIndicator = paraenElement.querySelector(`#_${intervalId}`) as HTMLElement;
  if (!loadingIndicator) return;

  clearInterval(intervalId);
  intervalId = null;
  loadingIndicator.remove();
}

export type UIMessageType = "info" | "warning" | "error" | "success";
const uiMessageTypeDurations: { [key in UIMessageType]: number } = {
  info: 3000,
  warning: 5000,
  error: 10000,
  success: 3000,
};
export function toastMessage(msg: string, type: UIMessageType = "info") {
  try {
    let errorContainer = document.getElementById("error-container");
    if (!errorContainer) {
      errorContainer = document.createElement("div");
      errorContainer.id = "error-container";
      errorContainer.classList.add("flex", "flex-col", "flex-content-start");
      document.body.appendChild(errorContainer);
    }

    const errorDiv = document.createElement("div");
    errorDiv.classList.add("message", type, "flex", "flex-row", "flex-content-start");

    const errorMessageDiv = document.createElement("div");
    errorMessageDiv.textContent = msg;

    const xDiv = document.createElement("div");
    xDiv.classList.add("close");
    const xSpan = document.createElement("span");
    xSpan.innerHTML = "&times;";
    xDiv.appendChild(xSpan);

    errorDiv.appendChild(errorMessageDiv);
    errorDiv.appendChild(xDiv);
    errorContainer.appendChild(errorDiv);

    xDiv.onclick = () => {
      errorDiv.remove();
    };

    setTimeout(() => {
      errorDiv.style.opacity = "0";
      setTimeout(() => {
        try {
          errorDiv.remove();
        } catch (error) {
          console.warn("Error removing message: ", error);
        }
      }, 1000);
    }, uiMessageTypeDurations[type]);
  } catch (error) {
    console.error("Error showing toast message: ", error);
  }
}
